import {
  BG_STYLES,
  BORDER_STYLES,
  Chip,
  COMMON_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";
import React from "react";
import { StyleSheet, Text, View } from "react-native";
import DiagnosisCard from "./DiagnosisCard";
import { FetchPastDiagnosisResponse } from "../models/diagnosis";
import { ROUTES as FARMER_360_ROUTES } from "app/farmer360/routes/types";
import { rnNavigation } from "app/utils/appConfig";
import {
  selectFarmerId,
  selectFarmerName,
  setPlantixUId,
} from "app/farmer360/store/app";
import { useAppDispatch, useAppSelector } from "app/hooks/reduxHooks";
import { trackEvent } from "app/farmer360/utils/tracking";
import { CustomEventTypes } from "../utils/events/CustomEventTypes";
import {
  setFarmerId,
  setFarmerName,
  setFarmerPhone,
} from "app/farmer360/store/app";
import User from "app/farmer360/KhetEdge/models/user";
import { fetchUserDetails } from "app/farmer360/KhetEdge/apis/fetchUserDetails";

interface PastDiagnosisProps {
  pastHistoryData: FetchPastDiagnosisResponse | null;
}
const PastDiagnosis = ({ pastHistoryData }: PastDiagnosisProps) => {
  const count = pastHistoryData ? pastHistoryData?.count : 0;
  const result = pastHistoryData ? pastHistoryData?.results : null;
  const farmerId = useAppSelector(selectFarmerId);
  const farmerName = useAppSelector(selectFarmerName);
  const dispatch = useAppDispatch();

  const getUserDetails = async () => {
    let user: User | null;
    user = await fetchUserDetails();
    if (user && user.id) {
      dispatch(setFarmerId(user.id));
      dispatch(setFarmerName(user.full_name!));
      dispatch(setFarmerPhone(user.phone_number));
    }
  };

  return (
    <View
      style={[
        COMMON_STYLES["pv3/2"],
        COMMON_STYLES.ph1,
        BG_STYLES.bgWhite,
        COMMON_STYLES.mt1,
      ]}
    >
      <View
        style={[
          COMMON_STYLES.row,
          COMMON_STYLES.justifyBetween,
          COMMON_STYLES.alignItemsCenter,
          COMMON_STYLES["mv1/2"],
        ]}
      >
        <View style={[COMMON_STYLES.alignItemsCenter]}>
          <Text
            style={[
              TEXT_STYLES.textNeutral80,
              TYPOGRAPHY.HEADING3,
              VARIANTS_STYLES.EMPHASIZED,
            ]}
          >
            Past Diagnosis ({count > 0 ? pastHistoryData?.count : ""})
          </Text>
        </View>

        {count > 2 && (
          <Chip
            label={"View All"}
            containerStyle={styles.chipContainer}
            labelStyle={styles.labelStyle}
            onClick={() => {
              getUserDetails().then(() => {
                trackEvent(CustomEventTypes.CropDocImageHomeViewAllClicked);
                rnNavigation({
                  name: FARMER_360_ROUTES.PREVIOUS_DIAGNOSIS,
                });
              });
            }}
          />
        )}
      </View>

      {result?.map((item, index) => (
        <DiagnosisCard
          key={item.plantix_id || index.toString()}
          date={
            item.created_date
              ? new Date(Number(item.created_date) * 1000).toLocaleDateString(
                  "en-IN",
                  {
                    day: "numeric",
                    month: "short",
                  }
                )
              : "Invalid Date"
          }
          id={item.plantix_id}
          title={item.disease_name || "Unknown Disease"}
          crop={item.crop_name_local || "Unknown Crop"}
          onPress={() => {
            getUserDetails().then(() => {
              dispatch(setPlantixUId(item.plantix_id));
              rnNavigation({
                name: FARMER_360_ROUTES.DISEASE_TREATMENT,
                params: {
                  diseaseId: item.disease_id,
                  cropName: item.crop_name_local!,
                  cropId: item.crop_id,
                },
              });
              trackEvent(CustomEventTypes.CropDocImagePastDiagnosisSelected, {
                DiseaseID: item.disease_id,
                DiseaseName: item.disease_name,
                CropID: item.crop_id,
                CropName: item.crop_name_local,
                FarmerID: farmerId,
                FarmerName: farmerName,
              });
            });
          }}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  chipContainer: {
    ...BG_STYLES.bgPrimary20,
    ...BORDER_STYLES.borderPrimary100,
  },
  labelStyle: {
    ...TEXT_STYLES.textPrimary100,
    ...TYPOGRAPHY.TEXT2,
    ...VARIANTS_STYLES.SEMI_EMPHASIZED,
  },
});

export default PastDiagnosis;
